module.exports = __webpack_public_path__ + "public/SiteImages/vectorFooterImage.svg?d696fdcb";